import MainService from "@/services/MainService.js";

window.$ = window.jQuery = require("jquery");

export default {
    name: "ReporteCargaMasivaPage",
    data() {
        let ss = new MainService();
        return {
            ss,
            flags: [],            // opciones para el select (array de strings { value, text })
            selectedFlag: null,
            loadingFlags: false,
            loadingList: false,
            list: [],             // lista de PersonaViatico filtrada por bandera
            fields: [
                { key: "id", label: "ID", sortable: true },
                { key: "Persona", label: "Código Persona" },
                { key: "ReparticionOrigen", label: "Repartición Origen" },
                { key: "ReparticionNueva", label: "Repartición Nueva" },
                { key: "FechaViatico", label: "Fecha" },
                { key: "Bandera", label: "Bandera" },
                { key: "EstadoViatico", label: "Estado" },
                // agrega campos que quieras mostrar
            ],
            message: "",
            messageVariant: "info",
            rutaApp: process.env.VUE_APP_MAIN_SERVICE,
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
        };
    },
    methods: {
        async mountedActions() {
            await this.fetchFlags();
        },

        async fetchFlags() {
            try {
                this.loadingFlags = true;
                const r = await this.ss.getViaticosFlags();
                // r.data expected: { flags: ['PRIMERA-2025-11-29', 'BETA-01', ...] }
                this.flags = (r.data?.data?.flags || []).map(f => ({ value: f, text: f }));
                // agregar opción vacía
                this.flags.unshift({ value: null, text: " -- Seleccione bandera -- " });
            } catch (e) {
                console.error(e);
                this.showMsg("No se pudieron obtener las banderas.", "danger");
            } finally {
                this.loadingFlags = false;
            }
        },

        async fetchByFlag() {
            if (!this.selectedFlag) return;
            try {
                this.loadingList = true;
                const r = await this.ss.getPersonaViaticoByFlag(this.selectedFlag);
                // expected r.data.items = []
                this.list = r.data?.data?.items || [];
                this.showMsg(`Se listaron ${this.list.length} registros.`, "success");
            } catch (e) {
                console.error(e);
                this.showMsg("Error al obtener la lista por bandera.", "danger");
            } finally {
                this.loadingList = false;
            }
        },

        async downloadReport() {
            if (!this.selectedFlag) return;
            try {
                const res = await this.ss.downloadReportByFlag(this.selectedFlag, { responseType: "blob" });
                const blob = new Blob([res.data], { type: res.headers['content-type'] || 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `reporte_carga_masiva_${this.selectedFlag}.csv`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            } catch (e) {
                console.error(e);
                this.showMsg("No se pudo descargar el reporte.", "danger");
            }
        },

        async refreshFlags() {
            await this.fetchFlags();
            this.showMsg("Banderas actualizadas.", "info");
        },

        showMsg(msg, variant = "info") {
            this.message = msg;
            this.messageVariant = variant;
            // también toast
            this.$bvToast.toast(msg, { title: variant === "danger" ? "Error" : "Info", variant, autoHideDelay: 4000 });
        },
        async printReporteByFlag() {
            if (!this.selectedFlag) {
                this.showMsg("Seleccione una bandera antes de generar el reporte.", "warning");
                return;
            }

            try {
                // muestra algo en consola para debug
                console.log("Generando reporte para bandera:", this.selectedFlag);

                const result = await this.ss.imprimirReporteByFlag(this.selectedFlag);
                // result.data === { success: true, data: { url: 'http://.../tmp/xxxx.pdf', ... }, msg: '...' }
                const response = result.data;

                if (response && response.success && response.data && response.data.url) {
                    // en tu código anterior usabas this.rutaApp + response.data.url
                    // si response.data.url ya es absoluta, esto no hará falta. Ajusta si es necesario.
                    window.open(this.rutaApp + response.data.url);
                    this.showMsg("Reporte generado.", "success");
                } else {
                    console.error("Respuesta inesperada del servidor:", response);
                    this.showMsg("No se pudo generar el reporte.", "danger");
                }
            } catch (error) {
                console.error(error);
                this.showMsg("Error al generar el reporte.", "danger");
            }
        }
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem("persona"));
        if (!persona) this.$router.push("/Login");
        this.mountedActions();
    }
};
